export const environment = {
  envName: 'dev',
  defaultLandingPage: 'map-search',
  googleAnalyticsMeasurementId: 'G-3NJ71KTWRM',
  production: false,
  SERVICE_HOST: 'https://api-dev.mtnra.com',
  PREDICT_SERVICE_HOST:'https://pnc-dev-api.mtnra.com/predict',
  PREDICT_API_KEY : 'aIbDOWen3H4xcWEnVlHNL4Jf0jusNXsglJebtAl4',
  GRADE_API_BASE_URL: 'https://cual6wiui7.execute-api.us-east-1.amazonaws.com/dev',
  GRADE_API_KEY: '5W142Df2YC3oZ68Ga0Opt1DcHdSnGfsV4ADObrqH',
  AUTH_CONFIG: {
    clientID: 'UlhbDSCLEV69ZARykf28NlIMwgyOD16K',
    domain: 'https://qa-sso.retailstat.com/',
    callbackURL: 'https://insights-dev.mtnra.com/authenticating',
    logoutURL: 'https://insights-dev.mtnra.com/logout',
    clientSecret : '3ovUVJQVxk-UlWEpoWa1oxpYaY2XewD7dN8MuLFtKMyTW-kxbfPSQbGtmejV3voY',
    MTNRAServiceUrl: 'https://qa-rs-ui.retailstat.com/api/services/mtn?relayState=https://insights-dev.mtnra.com/authenticating',
    RS_W_BASE_URL: 'https://qa-rs-ui.retailstat.com',
  },
  VERSION: require('../../package.json').version,
  GRAY_SCALE : '4214e56cca37bed7',
  GRAYSCALE_WITH_POI :'8fc4edfcb188f772',
  DARKTHEME : '4bbe431ce0178faa',
  DARKTHEME_WITH_POI : 'ab516a0641a8c292'
};
